import DeviceAlarms from './DeviceAlarms';

export default DeviceAlarms;